import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7005b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vacancy-response-form" }
const _hoisted_2 = { class: "vacancy-response-form__heading" }
const _hoisted_3 = { class: "vacancy-response-form__title ds-caption--ff_bahnschrift" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-preloader__item" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "vacancy-response-form__body" }
const _hoisted_7 = { class: "g-row g-row--appearance_spaced g-row--space_md" }
const _hoisted_8 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_9 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_10 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_11 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_12 = {
  key: 0,
  class: "error-label"
}
const _hoisted_13 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_15 = { class: "vacancy-response-form__upload-label" }
const _hoisted_16 = { class: "vacancy-response-form__upload-trigger" }
const _hoisted_17 = { class: "vacancy-response-form__upload-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "vacancy-response-form__upload-icon",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.6553 9.21967C16.725 9.28932 16.7803 9.37204 16.8181 9.46309C16.8558 9.55413 16.8753 9.65173 16.8753 9.75029C16.8753 9.84885 16.8558 9.94645 16.8181 10.0375C16.7803 10.1285 16.725 10.2113 16.6553 10.2809L8.9631 17.9684C7.97836 18.953 6.64281 19.5061 5.25027 19.506C3.85772 19.506 2.52225 18.9527 1.53763 17.9679C0.553014 16.9832 -8.78825e-05 15.6477 1.04736e-08 14.2551C8.79035e-05 12.8626 0.553359 11.5271 1.5381 10.5425L10.8437 1.09998C11.5468 0.396202 12.5006 0.000527974 13.4953 5.27999e-07C14.4901 -0.000526918 15.4443 0.394135 16.1481 1.09717C16.8519 1.8002 17.2476 2.75401 17.2481 3.74877C17.2486 4.74353 16.8539 5.69776 16.1509 6.40154L6.84341 15.844C6.42072 16.2667 5.84743 16.5042 5.24966 16.5042C4.65189 16.5042 4.0786 16.2667 3.65591 15.844C3.23322 15.4214 2.99576 14.8481 2.99576 14.2503C2.99576 13.6525 3.23322 13.0792 3.65591 12.6565L11.4653 4.72342C11.5337 4.65044 11.616 4.59188 11.7074 4.5512C11.7988 4.51051 11.8974 4.48851 11.9974 4.4865C12.0974 4.48448 12.1968 4.5025 12.2897 4.53947C12.3827 4.57645 12.4673 4.63165 12.5386 4.70181C12.6098 4.77198 12.6664 4.85569 12.7048 4.94804C12.7433 5.04038 12.7629 5.13948 12.7625 5.2395C12.762 5.33953 12.7416 5.43846 12.7024 5.53048C12.6632 5.62249 12.6059 5.70573 12.534 5.77529L4.72372 13.7169C4.6538 13.7862 4.59822 13.8687 4.56016 13.9596C4.5221 14.0504 4.50231 14.1479 4.50192 14.2464C4.50153 14.3449 4.52054 14.4425 4.55787 14.5336C4.59521 14.6248 4.65013 14.7077 4.71951 14.7776C4.78888 14.8476 4.87135 14.9031 4.9622 14.9412C5.05306 14.9793 5.15052 14.999 5.24902 14.9994C5.34753 14.9998 5.44514 14.9808 5.53629 14.9435C5.62745 14.9062 5.71036 14.8512 5.78029 14.7819L15.0868 5.34404C15.5095 4.92222 15.7473 4.34977 15.748 3.75261C15.7486 3.15545 15.5119 2.58251 15.0901 2.15982C14.6683 1.73713 14.0959 1.49932 13.4987 1.49871C12.9015 1.49809 12.3286 1.73472 11.9059 2.15654L2.60216 11.5953C2.25363 11.9433 1.97704 12.3565 1.7882 12.8114C1.59936 13.2662 1.50197 13.7539 1.50158 14.2464C1.50119 14.7389 1.59781 15.2267 1.78592 15.6818C1.97403 16.137 2.24996 16.5507 2.59794 16.8992C2.94593 17.2477 3.35915 17.5243 3.81402 17.7132C4.2689 17.902 4.75651 17.9994 5.24902 17.9998C5.74154 18.0002 6.2293 17.9036 6.68448 17.7154C7.13965 17.5273 7.55331 17.2514 7.90185 16.9034L15.595 9.21592C15.7361 9.07587 15.9271 8.99759 16.1259 8.99829C16.3247 8.999 16.5151 9.07862 16.6553 9.21967Z",
    fill: "#7C7C7C"
  })
], -1))
const _hoisted_19 = { class: "vacancy-response-form__upload-btn" }
const _hoisted_20 = { class: "vacancy-response-form__upload-hint" }
const _hoisted_21 = { class: "g-cell g-cols g-cols--12 g-cols--6-md" }
const _hoisted_22 = { class: "vacancy-response-form__upload-label" }
const _hoisted_23 = { class: "vacancy-response-form__upload-trigger" }
const _hoisted_24 = { class: "vacancy-response-form__upload-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "vacancy-response-form__upload-icon",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.6553 9.21967C16.725 9.28932 16.7803 9.37204 16.8181 9.46309C16.8558 9.55413 16.8753 9.65173 16.8753 9.75029C16.8753 9.84885 16.8558 9.94645 16.8181 10.0375C16.7803 10.1285 16.725 10.2113 16.6553 10.2809L8.9631 17.9684C7.97836 18.953 6.64281 19.5061 5.25027 19.506C3.85772 19.506 2.52225 18.9527 1.53763 17.9679C0.553014 16.9832 -8.78825e-05 15.6477 1.04736e-08 14.2551C8.79035e-05 12.8626 0.553359 11.5271 1.5381 10.5425L10.8437 1.09998C11.5468 0.396202 12.5006 0.000527974 13.4953 5.27999e-07C14.4901 -0.000526918 15.4443 0.394135 16.1481 1.09717C16.8519 1.8002 17.2476 2.75401 17.2481 3.74877C17.2486 4.74353 16.8539 5.69776 16.1509 6.40154L6.84341 15.844C6.42072 16.2667 5.84743 16.5042 5.24966 16.5042C4.65189 16.5042 4.0786 16.2667 3.65591 15.844C3.23322 15.4214 2.99576 14.8481 2.99576 14.2503C2.99576 13.6525 3.23322 13.0792 3.65591 12.6565L11.4653 4.72342C11.5337 4.65044 11.616 4.59188 11.7074 4.5512C11.7988 4.51051 11.8974 4.48851 11.9974 4.4865C12.0974 4.48448 12.1968 4.5025 12.2897 4.53947C12.3827 4.57645 12.4673 4.63165 12.5386 4.70181C12.6098 4.77198 12.6664 4.85569 12.7048 4.94804C12.7433 5.04038 12.7629 5.13948 12.7625 5.2395C12.762 5.33953 12.7416 5.43846 12.7024 5.53048C12.6632 5.62249 12.6059 5.70573 12.534 5.77529L4.72372 13.7169C4.6538 13.7862 4.59822 13.8687 4.56016 13.9596C4.5221 14.0504 4.50231 14.1479 4.50192 14.2464C4.50153 14.3449 4.52054 14.4425 4.55787 14.5336C4.59521 14.6248 4.65013 14.7077 4.71951 14.7776C4.78888 14.8476 4.87135 14.9031 4.9622 14.9412C5.05306 14.9793 5.15052 14.999 5.24902 14.9994C5.34753 14.9998 5.44514 14.9808 5.53629 14.9435C5.62745 14.9062 5.71036 14.8512 5.78029 14.7819L15.0868 5.34404C15.5095 4.92222 15.7473 4.34977 15.748 3.75261C15.7486 3.15545 15.5119 2.58251 15.0901 2.15982C14.6683 1.73713 14.0959 1.49932 13.4987 1.49871C12.9015 1.49809 12.3286 1.73472 11.9059 2.15654L2.60216 11.5953C2.25363 11.9433 1.97704 12.3565 1.7882 12.8114C1.59936 13.2662 1.50197 13.7539 1.50158 14.2464C1.50119 14.7389 1.59781 15.2267 1.78592 15.6818C1.97403 16.137 2.24996 16.5507 2.59794 16.8992C2.94593 17.2477 3.35915 17.5243 3.81402 17.7132C4.2689 17.902 4.75651 17.9994 5.24902 17.9998C5.74154 18.0002 6.2293 17.9036 6.68448 17.7154C7.13965 17.5273 7.55331 17.2514 7.90185 16.9034L15.595 9.21592C15.7361 9.07587 15.9271 8.99759 16.1259 8.99829C16.3247 8.999 16.5151 9.07862 16.6553 9.21967Z",
    fill: "#7C7C7C"
  })
], -1))
const _hoisted_26 = { class: "vacancy-response-form__upload-btn" }
const _hoisted_27 = { class: "vacancy-response-form__upload-hint" }
const _hoisted_28 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_29 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_30 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_31 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_32 = { class: "vacancy-response-form__checkboxes" }
const _hoisted_33 = { class: "d-control-checkbox d-control-checkbox--variant_flex" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-control-checkbox__label" }, null, -1))
const _hoisted_35 = { class: "d-control-checkbox__content" }
const _hoisted_36 = { class: "d-control-checkbox d-control-checkbox--variant_flex" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-control-checkbox__label" }, null, -1))
const _hoisted_38 = { class: "d-control-checkbox__content" }
const _hoisted_39 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_40 = { class: "error-label" }
const _hoisted_41 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_42 = { class: "error-label" }
const _hoisted_43 = { class: "g-cell g-cols g-cols--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_input = _resolveComponent("control-input")!
  const _component_InputLabel = _resolveComponent("InputLabel")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_VeeField = _resolveComponent("VeeField")!
  const _component_control_uploader = _resolveComponent("control-uploader")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_control_button = _resolveComponent("control-button")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, { onSubmit: $setup.send }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('Відгукнутись на вакансію')), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["i-preloader", { 'is-active': $setup.isLoad }])
        }, _hoisted_5, 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_control_input, {
                name: "last_name",
                type: "text",
                rules: "required|max:150",
                errors: errors,
                "input-label": _ctx.$t('Прізвище'),
                placeholder: _ctx.$t('Введіть Прізвище'),
                modelValue: $setup.formdata.last_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.last_name) = $event))
              }, null, 8, ["errors", "input-label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_control_input, {
                name: "first_name",
                type: "text",
                rules: "required|max:150",
                errors: errors,
                "input-label": _ctx.$t("Ім'я"),
                placeholder: _ctx.$t("Введіть Ім'я"),
                modelValue: $setup.formdata.first_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formdata.first_name) = $event))
              }, null, 8, ["errors", "input-label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_control_input, {
                name: "middle_name",
                type: "text",
                rules: "required|max:150",
                errors: errors,
                "input-label": _ctx.$t('По-батькові'),
                placeholder: _ctx.$t('Введіть По-батькові'),
                modelValue: $setup.formdata.middle_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formdata.middle_name) = $event))
              }, null, 8, ["errors", "input-label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["d-control-descriptor", { error: errors.phone }])
              }, [
                _createVNode(_component_InputLabel, {
                  "input-label": _ctx.$t('Телефон'),
                  "is-required": true
                }, null, 8, ["input-label"]),
                _createVNode(_component_VeeField, {
                  name: "phone",
                  modelValue: $setup.formdata.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formdata.phone) = $event)),
                  rules: "required|validPhone",
                  "validate-on-mount": false,
                  "validate-on-model-update": false
                }, {
                  default: _withCtx(({ componentField, meta }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({ class: "vacancy-response-form__phone-input" }, componentField, {
                      "default-country": "UA",
                      mode: "international",
                      "dropdown-options": { showFlags: true, showDialCodeInSelection: true },
                      "preferred-countries": ['ua', 'pl', 'de'],
                      "input-options": { placeholder: _ctx.$t('Введіть номер телефону'), name: 'phone' }
                    }), null, 16, ["input-options"]),
                    ((meta.touched || meta.validated) && errors.phone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errors.phone), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_control_input, {
                name: "email",
                type: "email",
                rules: "required|email",
                errors: errors,
                "input-label": _ctx.$t('Email'),
                placeholder: _ctx.$t('Введіть свій Email'),
                modelValue: $setup.formdata.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formdata.email) = $event))
              }, null, 8, ["errors", "input-label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('Прикріпити файл 1')), 1),
              _createVNode(_component_control_uploader, {
                class: "vacancy-response-form__uploader",
                "input-id": "attachment_1",
                "max-files": 1,
                "max-size": 5,
                "accepted-files": ['doc','docx','txt','rtf','odt','pdf'],
                "hide-trigger-when-has-files": true,
                modelValue: $setup.formdata.attachment1,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formdata.attachment1) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Обрати файл')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, ".doc, .docx, .txt, .rtf, .odt, .pdf " + _toDisplayString(_ctx.$t('до 5 МБ')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('Прикріпити файл 2')), 1),
              _createVNode(_component_control_uploader, {
                class: "vacancy-response-form__uploader",
                "input-id": "attachment_2",
                "max-files": 1,
                "max-size": 5,
                "accepted-files": ['doc','docx','txt','rtf','odt','pdf'],
                "hide-trigger-when-has-files": true,
                modelValue: $setup.formdata.attachment2,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formdata.attachment2) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('Обрати файл')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, ".doc, .docx, .txt, .rtf, .odt, .pdf " + _toDisplayString(_ctx.$t('до 5 МБ')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_control_input, {
                name: "resume_link",
                type: "url",
                rules: "url",
                errors: errors,
                "input-label": _ctx.$t('Посилання на резюме'),
                placeholder: "https://...",
                modelValue: $setup.formdata.resume_link,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formdata.resume_link) = $event))
              }, null, 8, ["errors", "input-label", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_control_select, {
                modelValue: $setup.formdata.sourceOption,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formdata.sourceOption) = $event)),
                name: "source",
                "option-label": "label",
                options: $setup.sourceOptions,
                errors: errors,
                "input-label": _ctx.$t('Як ви дізнались про вакансію?'),
                placeholder: _ctx.$t('Оберіть варіант'),
                "allow-empty": true,
                searchable: true
              }, null, 8, ["modelValue", "errors", "input-label", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_control_input, {
                component: "SimpleTextarea",
                name: "cover_letter",
                type: "text",
                rules: "max:1000",
                rows: "4",
                errors: errors,
                "input-label": _ctx.$t('Коментар / Супровідний лист'),
                placeholder: _ctx.$t('Розкажіть про себе та чому ви підходите для цієї позиції...'),
                modelValue: $setup.formdata.cover_letter,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formdata.cover_letter) = $event))
              }, null, 8, ["errors", "input-label", "placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_VeeField, {
                  type: "checkbox",
                  name: "privacy_accepted",
                  rules: "required",
                  "unchecked-value": false,
                  modelValue: $setup.formdata.privacy_accepted,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formdata.privacy_accepted) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        class: "d-control-checkbox__element",
                        name: "privacy_accepted",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formdata.privacy_accepted) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, $setup.formdata.privacy_accepted]
                      ]),
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('Я прочитав(-ла) та приймаю ')), 1),
                          _createElementVNode("a", {
                            class: "vacancy-response-form__link",
                            href: "#",
                            onClick: _withModifiers($setup.openTerms, ["prevent"])
                          }, _toDisplayString(_ctx.$t('ПРАВИЛА ТА УМОВИ ')), 1),
                          _createTextVNode(_toDisplayString(_ctx.$t('і ')), 1),
                          _createElementVNode("a", {
                            class: "vacancy-response-form__link",
                            href: "#",
                            onClick: _withModifiers($setup.openConfidentiality, ["prevent"])
                          }, _toDisplayString(_ctx.$t('Політику конфіденційності')), 1),
                          _createTextVNode(".")
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    class: "d-control-checkbox__element",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.formdata.newsletter_accepted) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, $setup.formdata.newsletter_accepted]
                  ]),
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('Я хочу отримувати оновлення про актуальні вакансії, новини компанії, події та маркетингові пропозиції.')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode(_component_VeeError, { name: "privacy_accepted" }, {
              default: _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(message), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
              default: _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(message), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_control_button, {
                class: "vacancy-response-form__submit-btn",
                disabled: $setup.isLoad,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Відправити')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}